import React from 'react';
import ImageMessage from './ImageMessage';
import AudioMessage from './AudioMessage';
import VideoMessage from './VideoMessage';
import DocumentMessage from './DocumentMessage';
import VoiceMessage from './VoiceMessage';
import { getMediaType, getFileCategory } from '../../utils/mediaHelpers';

const MediaMessage = ({ message, isSender }) => {
  const { media, text, timestamp } = message;
  
  if (!media) {
    return (
      <div className={`message ${isSender ? 'message-sender' : 'message-receiver'}`}>
        <div className="message-content">
          {text}
        </div>
        <div className="message-time">
          {new Date(timestamp).toLocaleTimeString([], { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}
        </div>
      </div>
    );
  }

  // Use AI-assisted media type detection with filename context
  const mediaType = getMediaType(media.mimeType, media.originalName);
  const fileCategory = getFileCategory(media.mimeType, media.originalName);
  
  // Render appropriate media component based on type
  const renderMediaComponent = () => {
    switch (mediaType) {
      case 'image':
        return (
          <ImageMessage 
            media={media}
            caption={text}
            isSender={isSender}
            category={fileCategory}
          />
        );
      case 'audio':
        return (
          <AudioMessage 
            media={media}
            caption={text}
            isSender={isSender}
            category={fileCategory}
          />
        );
      case 'voice':
        return (
          <VoiceMessage 
            media={media}
            caption={text}
            isSender={isSender}
            category={fileCategory}
          />
        );
      case 'video':
        return (
          <VideoMessage 
            media={media}
            caption={text}
            isSender={isSender}
            category={fileCategory}
          />
        );
      case 'document':
        return (
          <DocumentMessage 
            media={media}
            caption={text}
            isSender={isSender}
            category={fileCategory}
          />
        );
      default:
        return (
          <div className="media-fallback">
            <div className="fallback-content">
              <div className="fallback-icon">📎</div>
              <div className="fallback-info">
                <p className="fallback-name">{media.originalName}</p>
                <p className="fallback-type">Unsupported file type</p>
                <button 
                  className="fallback-download"
                  onClick={() => {
                    const link = document.createElement('a');
                    link.href = media.url;
                    link.download = media.originalName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                >
                  Download File
                </button>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <div className={`message ${isSender ? 'message-sender' : 'message-receiver'}`}>
      {renderMediaComponent()}
    </div>
  );
};

export default MediaMessage;
